/**
* Created by Jaime Bonilla Venegas on 2017-06-13.
* Item model for each "Conceptos"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Trash from 'material-ui/svg-icons/action/delete';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInlineV2 } from '../../../components/text';
import Edit from 'material-ui/svg-icons/content/create';
import { setValueIn } from '../../../common/immutable';
import IconButton from 'material-ui/IconButton';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';
import { Alert } from '../../../components/data-containers';

//Fields goes here, it might corresponds with the names of the props
//you modify on state
const errorsProps = {
    concept: [],
    applicable: [],
    tax: [],
    aditionalTax: [],
    retentions: []
};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber
const rules = {
    concept: [{ key: 'required', errorText: 'Campo requerido' }],
    applicable: [{ key: 'required', errorText: 'Campo requerido' }],
    tax: [{ key: 'onlyNumbers', errorText: 'Solo numeros enteros' }, { key: 'validationInvoiceItem', errorText: 'El impuesto puede tener 9 digitos maximo' }],
    aditionalTax: [{ key: 'onlyNumbers', errorText: 'Solo numeros enteros' }, {key: 'validationInvoiceItem', errorText: 'El impuesto adicional puede tener 9 digitos maximo'}],
    retentions: [{ key: 'percentajeValues', errorText: 'Por favor no agrege letras ni signos' }, {key: 'validationInvoiceItem', errorText: 'Las retenciones pueden  tener 9 digitos maximo'}]
};

class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            invoiceItem: props.invoiceItem,
            errors: { ...errorsProps },
            openAlert: false
        };
    }

    updateInvoiceItem(path, value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );

        const invoiceItem = setValueIn(parsePath(path), value, this.state.invoiceItem);
        this.setState({ invoiceItem, errors });
    }

    renderButtons(editing, invoiceItem, onSave) {
        const { allowUpdate, allowDelete } = this.props;

        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, invoiceItem, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state.invoiceItem);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowUpdate) { return; }
                            this.setState({ invoiceItem: invoiceItem })
                            this.setState({ editing: true });
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowDelete) && <IconButton
                        tooltip="Eliminar concepto de facturacion"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowDelete) { return; }
                            this.setState({ openAlert: true });
                        }}
                    >
                        <Trash />
                    </IconButton>
                }
            </div>
        );
    }

    render() {
        const { editing, errors } = this.state;
        const { invoiceItem, onSave, actions } = this.props;
        const currentProperties = editing ? this.state.invoiceItem : invoiceItem;
        const { concept, applicable, tax, aditionalTax, retentions, applicableRepresentation } = currentProperties;
        
        return (
            <div className="col-md-12 margin-bottom-2 pl0" key={this.props.invoiceItem.id}>
                <div className="item-row">
                    <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 white-card box-shadow padding-1 vcenter">
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={concept}
                                label="Concepto"
                                notify={(value) => { this.updateInvoiceItem('concept', value, 'concept') }}
                                errorText={errors.concept.join(' | ')}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="autocomplete"
                                value={getValueFromSelectList([
                                  { id: 'PEDIMENTO', name: 'Por Pedimento' },
                                  { id: 'CONTENEDOR/EQUIPO/LCL', name: 'Por Contenedor/Equipo/LCL' },
                                  { id: 'EMBARQUE/OPERACION', name: ' Por Embarque u Operación' },
                                  { id: 'FACTURA', name: ' Por Factura' },
                                  { id: 'DOCUMENTO', name: ' Por Documento' },
                                  { id: 'PARTIDA EXTRA', name: ' Por Partida Extra' },
                                  { id: 'DIA/HORA/EVENTO', name: ' Por Dia/Hora/Evento' },
                                  { id: 'BL/GUIA', name: ' Por BL o Guia' },
                                  { id: 'EQUIPO/CAJA/CAMION', name: ' Por Equipo/Caja/Camión' },
                                ], applicable).name}
                                label="Aplicable"
                                items={[
                                  { id: 'PEDIMENTO', name: 'Por Pedimento' },
                                  { id: 'CONTENEDOR/EQUIPO/LCL', name: 'Por Contenedor/Equipo/LCL' },
                                  { id: 'EMBARQUE/OPERACION', name: ' Por Embarque u Operación' },
                                  { id: 'FACTURA', name: ' Por Factura' },
                                  { id: 'DOCUMENTO', name: ' Por Documento' },
                                  { id: 'PARTIDA EXTRA', name: ' Por Partida Extra' },
                                  { id: 'DIA/HORA/EVENTO', name: ' Por Dia/Hora/Evento' },
                                  { id: 'BL/GUIA', name: ' Por BL o Guia' },
                                  { id: 'EQUIPO/CAJA/CAMION', name: ' Por Equipo/Caja/Camión' },
                                ]}
                                editViewActive={editing}
                                notify={(value) => {
                                    this.updateInvoiceItem('applicable', value.id, 'applicable')
                                    if (value.name != value.id) {
                                        this.updateInvoiceItem('applicableRepresentation', value.name, 'applicableRepresentation')
                                    }
                                }}
                                errorText={errors.applicable.join(' | ')}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={tax}
                                label="IVA %"
                                notify={(value) => { this.updateInvoiceItem('tax', value, 'tax') }}
                                errorText={errors.tax.join(' | ')}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={aditionalTax}
                                label="Impuesto adicional %"
                                notify={(value) => { this.updateInvoiceItem('aditionalTax', value, 'aditionalTax') }}
                                errorText={errors.aditionalTax.join(' | ')}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={retentions}
                                label="Retencion %"
                                notify={(value) => { this.updateInvoiceItem('retentions', value, 'retentions') }}
                                errorText={errors.retentions.join(' | ')}
                            />
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-8 col-xs-5 vcenter hidden-lg-up">
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-7 vcenter edit-buttons text-center">
                        {this.renderButtons(editing, invoiceItem, onSave)}
                    </div>
                    <Alert
                        open={this.state.openAlert}
                        close={() => this.setState({ openAlert: false })}
                        message={"Seguro que quieres eliminar este cliente?"}
                        delteEntry={() => {
                            this.setState({ openAlert: false });
                            actions.deleteInvoiceItem(invoiceItem);
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/conceptos/components/item.js